<template>
  <div class="question-form">
    <el-form-item label="题目标题"
                  :prop="fieldProp('title')">
      <el-input v-model="form.title"
                clearable
                :disabled="readonly"
                maxlength="200"
                placeholder="请输入题目内容"/>
    </el-form-item>
    <el-form-item label="题目示例"
                  :prop="fieldProp('sample_files')">
      <div class="sample-upload-group">
        <div class="sample-upload-block">
          <training-file-upload
            v-model="form.sample_files"
            :accept-types="[TRAINING_UPLOAD_TYPES.IMAGE,TRAINING_UPLOAD_TYPES.VIDEO]"
            :multiple="true"
            variant="button"
            button-text="添加题目示例"
            button-icon="el-icon-picture-outline"
            :disabled="readonly"
            @change="validateField('sample_files')"
            @uploading-change="$emit('uploading-change', $event)"/>
        </div>
      </div>
    </el-form-item>

    <el-form-item v-if="isChoiceQuestion"
                  label="答案选项"
                  :prop="fieldProp('standard_answer')">
      <div class="answer-tip">点击选中正确答案</div>
      <div v-for="(option, index) in form.options"
           :key="option.uuid"
           class="option-row">
        <span class="option-row__letter">{{ getOptionLetter(index) }}.</span>
        <el-radio
          v-if="isSingleQuestion"
          v-model="form.standard_answer"
          :disabled="answerLocked"
          :label="option.uuid">&nbsp;
        </el-radio>
        <el-checkbox
          v-else
          :disabled="answerLocked"
          :value="multiAnswerValue.includes(option.uuid)"
          @change="checked => onMultiAnswerChanged(option.uuid, checked)">&nbsp;
        </el-checkbox>
        <el-input v-model="option.title"
                  class="option-row__input"
                  :disabled="readonly"
                  placeholder="请输入选项内容"/>
        <el-button
          type="text"
          icon="el-icon-delete"
          :disabled="optionStructureLocked || form.options.length <= 1"
          @click="removeOption(index)"/>
      </div>
      <el-button type="text"
                 icon="el-icon-plus"
                 :disabled="optionStructureLocked"
                 @click="addOption">添加选项
      </el-button>
    </el-form-item>

    <el-form-item v-else
                  label="标准答案"
                  :prop="fieldProp('standard_answer')">
      <el-input v-model="blankAnswerValue"
                clearable
                :disabled="answerLocked"
                placeholder="请输入数字答案"/>
    </el-form-item>

    <el-form-item label="题目解析">
      <el-input
        v-model="form.analysis_text"
        type="textarea"
        :rows="4"
        :disabled="readonly"
        maxlength="1000"
        placeholder="请输入题目解析说明"/>
    </el-form-item>
    <el-form-item label="解析附件"
                  :prop="fieldProp('analysis_files')">
      <training-file-upload
        v-model="form.analysis_files"
        :accept-types="[TRAINING_UPLOAD_TYPES.IMAGE,TRAINING_UPLOAD_TYPES.VIDEO]"
        :multiple="true"
        variant="button"
        button-text="添加解析附件"
        button-icon="el-icon-upload"
        :disabled="readonly"
        @change="validateField('analysis_files')"
        @uploading-change="$emit('uploading-change', $event)"/>
    </el-form-item>
  </div>
</template>

<script>
import TrainingFileUpload from '@views/training/components/TrainingFileUpload.vue'
import { TRAINING_UPLOAD_TYPES } from '@views/training/components/training-upload'
import {
  isChoiceQuestion,
  consts,
  getOptionLetter,
  createOptionUuid
} from '@views/training/training-question.constants'

export default {
  name: 'QuestionForm',
  components: {
    TrainingFileUpload,
  },
  props: {
    form: {
      type: Object,
      required: true,
    },
    questionType: {
      type: [Number, String],
      required: true,
    },
    // 查看模式
    isViewMode: {
      type: Boolean,
      default: true,
    },
    // 答案选择是否禁用
    isAnswerLocked: {
      type: Boolean,
      default: false,
    },

    // 选项新增删除修改是否禁用
    isOptionStructureLocked: {
      type: Boolean,
      default: false,
    },
    propPrefix: {
      type: String,
      default: '',
    },
  },
  data () {
    return {
      consts,
      TRAINING_UPLOAD_TYPES,
    }
  },
  computed: {
    normalizedQuestionType () {
      return Number(this.questionType)
    },
    isChoiceQuestion () {
      return isChoiceQuestion(this.normalizedQuestionType)
    },
    isSingleQuestion () {
      return this.normalizedQuestionType === consts.QUESTION_TYPE_SINGLE
    },
    isMultiQuestion () {
      return this.normalizedQuestionType === consts.QUESTION_TYPE_MULTI
    },
    readonly () {
      return this.isViewMode
    },
    answerLocked () {
      return this.readonly || this.isAnswerLocked
    },
    optionStructureLocked () {
      return this.readonly || this.isOptionStructureLocked
    },
    multiAnswerValue () {
      return Array.isArray(this.form.standard_answer) ? this.form.standard_answer : []
    },
    blankAnswerValue: {
      get () {
        return Array.isArray(this.form.standard_answer) ? '' : this.form.standard_answer
      },
      set (value) {
        this.form.standard_answer = value
      },
    },
  },
  methods: {
    getOptionLetter,
    addOption () {
      if (this.optionStructureLocked) {
        return
      }
      this.form.options.push({
        uuid: createOptionUuid(),
        title: `选项${this.getOptionLetter(this.form.options.length)}`,
      })
    },
    onMultiAnswerChanged (uuid, checked) {
      if (this.answerLocked || !this.isMultiQuestion) {
        return
      }
      const answer = this.multiAnswerValue.slice()
      if (checked && !answer.includes(uuid)) {
        answer.push(uuid)
      }
      if (!checked) {
        this.form.standard_answer = answer.filter(item => item !== uuid)
      } else {
        this.form.standard_answer = answer
      }
      // this.validateField('standard_answer')
    },
    removeOption (index) {
      if (this.optionStructureLocked) {
        return
      }
      const option = this.form.options[index]
      this.form.options.splice(index, 1)
      if (this.isSingleQuestion && this.form.standard_answer === option.uuid) {
        this.form.standard_answer = ''
      }
      if (this.isMultiQuestion) {
        this.form.standard_answer = this.multiAnswerValue.filter(uuid => uuid !== option.uuid)
      }
      // this.validateField('standard_answer')
    },
    validateField (field) {
      this.$emit('validate-field', this.fieldProp(field))
    },
    fieldProp (field) {
      return this.propPrefix ? `${this.propPrefix}.${field}` : field
    },
  },
}
</script>

<style scoped lang="scss">
.answer-tip {
  margin-bottom: 8px;
  color: #8492a6;
  font-size: 12px;
}

.option-row {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.option-row__letter {
  width: 22px;
  color: #1f2d3d;
}

.option-row__input {
  flex: 1;
}

.sample-upload-group {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/training/components/QuestionForm.vue